// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.verfy-wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: url('mesh-gradient.d2e368c6b9d92bb7.png') center center;
  background-size: cover;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}
.verfy-wrap .verfy-screen-logo {
  margin-top: 40px;
  margin-bottom: 20px;
}
.verfy-wrap .verfy-box {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 40px 60px;
  text-align: center;
  width: 600px;
  margin-top: 170px;
  max-width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: margin-top 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s;
  box-sizing: border-box;
  /* PDF Viewer Container */
  /* Signature Sidebar Panel */
  /* Receipt card styling */
  /* Success / Error icon containers */
}
.verfy-wrap .verfy-box.wide-box {
  width: 95%;
  max-width: 1400px;
  padding: 30px 40px;
  margin-top: 50px;
}
.verfy-wrap .verfy-box h2 {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  color: #1f2937;
  margin-top: 0;
  margin-bottom: 12px;
}
.verfy-wrap .verfy-box p.subtitle {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #4b5563;
  margin-bottom: 24px;
}
.verfy-wrap .verfy-box .Verify-dob {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 30px;
  padding: 0 16px;
  height: 52px;
  position: relative;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.verfy-wrap .verfy-box .Verify-dob:focus-within {
  border-color: #2D388B;
  box-shadow: 0 0 0 3px rgba(45, 56, 139, 0.15);
}
.verfy-wrap .verfy-box .Verify-dob img {
  width: 20px;
  opacity: 0.6;
}
.verfy-wrap .verfy-box .Verify-dob .input-mask-field {
  border: none;
  outline: none;
  width: 100%;
  font-size: 16px;
}
.verfy-wrap .verfy-box .pdf-container {
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  height: 750px;
  position: relative;
}
.verfy-wrap .verfy-box .pdf-container .pdf-viewer-scroll {
  cursor: grab;
}
.verfy-wrap .verfy-box .sign-controls-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 400px;
  background: #f9fafb;
}
.verfy-wrap .verfy-box .receipt-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.01);
}
.verfy-wrap .verfy-box .status-icon-container {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
}
.verfy-wrap .verfy-box .status-icon-container.success-bg {
  background: #ecfdf5;
}
.verfy-wrap .verfy-box .status-icon-container.error-bg {
  background: #fef2f2;
}

.verify-agency-logo {
  max-height: 80px;
  max-width: 300px;
  object-fit: contain;
}

.powered-wrapper {
  margin-top: 40px;
  margin-bottom: 20px;
  display: flex;
  gap: 6px;
  flex-direction: column;
  align-items: center;
}
.powered-wrapper span {
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #4b5563;
}
.powered-wrapper .image-wrapper {
  width: 140px;
}
.powered-wrapper .image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Animations */
.fade-in {
  animation: fadeIn 0.4s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Custom Overrides for Calendar/PrimeNG Inputs */
::ng-deep .disable-calendar .p-calendar {
  width: 100%;
}
::ng-deep .disable-calendar .p-inputtext {
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  height: 48px;
  font-size: 16px;
  width: 100%;
}
::ng-deep .p-checkbox .p-checkbox-box {
  border-radius: 4px;
  border-color: #d1d5db;
}
::ng-deep .p-checkbox .p-checkbox-box.p-highlight {
  background: #2D388B;
  border-color: #2D388B;
}

@media (max-width: 991px), (pointer: coarse) {
  .verfy-wrap .verfy-box {
    width: 100%;
    padding: 30px 20px;
    margin-top: 10px;
  }
  .verfy-wrap .verfy-box.wide-box {
    width: 100%;
    padding: 24px 16px;
  }
  .verfy-wrap .verfy-box .pdf-container {
    height: 400px;
  }
  .verfy-wrap .verfy-box .sign-controls-card {
    min-height: auto;
    margin-top: 20px;
  }
}
/* Caveat handwriting font for typed signatures. CDN-first with a self-hosted fallback: the
   browser tries the CDN, and if that request fails (offline, blocked on a locked-down clinical
   network, or a stale URL) it uses the bundled copy — so the signature always renders in the
   font the signer saw, and the WYSIWYG guarantee holds everywhere.
   Caveat is licensed under the SIL Open Font License 1.1 — see src/assets/fonts/OFL.txt. */
@font-face {
  font-family: "Caveat";
  font-style: normal;
  font-weight: 700;
  /* 'block' (not 'swap') so the typed signature never renders in a fallback font and then visibly
     swaps to Caveat — during the brief load it stays hidden instead of flashing the wrong font.
     Combined with the ngOnInit preload, Caveat is loaded well before the Type step, so there is no
     visible delay in practice. */
  font-display: block;
  src: url("https://cdn.jsdelivr.net/npm/@fontsource/caveat/files/caveat-latin-700-normal.woff2") format("woff2"), url("/assets/fonts/caveat-700.woff2") format("woff2");
}
.sig-tabs {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2px;
  display: flex;
  gap: 4px;
}

.sig-tab-btn {
  flex: 1;
  background: transparent;
  border: none;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  outline: none;
}
.sig-tab-btn:hover {
  color: #1f2937;
  background: rgba(255, 255, 255, 0.5);
}
.sig-tab-btn.active {
  background: #ffffff;
  color: #2d388b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.sig-tab-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sig-panel {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.sig-canvas {
  touch-action: none; /* prevent browser scrolling while drawing */
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  transition: border-color 0.2s;
  display: block;
}
.sig-canvas:hover {
  border-color: #9ca3af;
}

.type-sig-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  background-color: #f9fafb;
  color: #000000; /* typed signature ink is black (matches drawn signatures) */
  font-weight: bold;
}

/* Unified accent ink (io navy) — replaces the stray indigo/purple accents on the
   signing page so labels, badges and the typed-signature preview match the theme. */
.io-ink {
  color: #2D388B;
}

.io-ink-soft-bg {
  background: #eef1fb;
}

::ng-deep .esign-green-btn {
  background: #6ACE6A !important;
  border: 1px solid #6ACE6A !important;
  color: #ffffff !important;
  transition: background-color 0.2s, border-color 0.2s;
}
::ng-deep .esign-green-btn:hover:not(:disabled) {
  background: #7AEC7A !important;
  border-color: #7AEC7A !important;
}
::ng-deep .esign-green-btn:focus:not(:disabled) {
  background: #5CB85C !important;
  border-color: #5CB85C !important;
}
::ng-deep .esign-green-btn:active:not(:disabled) {
  background: #5CB85C !important;
  border-color: #5CB85C !important;
}
::ng-deep .esign-green-btn:disabled {
  opacity: 0.6 !important;
  background: #6ACE6A !important;
  border-color: #6ACE6A !important;
  cursor: not-allowed !important;
}

/* PDF.js Annotation Layer Styles (Read-only for patient) */
::ng-deep {
  /* Hide all widgets in the annotation layer completely to prevent duplicate text overlay, but keep them in layout tree for auto-placement */
  /* Fields this signer fills in (IOHB-1779): shown and editable over the page. The opaque background
     covers the page's own rendering of the field underneath, so a value never shows twice. */
  /* The field the signer is on (IOHB-1884), outlined in the same yellow as the active signature box */
  /* Guide text in an empty field the signer fills in (IOHB-1886), in the colour of "Sign Here" */
}
::ng-deep .annotationLayer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 1;
  line-height: 1;
  pointer-events: none !important; /* Patient cannot interact/change values */
}
::ng-deep .annotationLayer > * {
  position: absolute;
  pointer-events: none !important;
  box-sizing: border-box;
}
::ng-deep .annotationLayer .linkAnnotation > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none !important;
}
::ng-deep .annotationLayer input,
::ng-deep .annotationLayer textarea,
::ng-deep .annotationLayer select,
::ng-deep .annotationLayer button,
::ng-deep .annotationLayer .buttonWidgetAnnotation,
::ng-deep .annotationLayer .textWidgetAnnotation,
::ng-deep .annotationLayer .choiceWidgetAnnotation {
  opacity: 0 !important;
  pointer-events: none !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}
::ng-deep .annotationLayer section.esign-fill-field {
  opacity: 1 !important;
  pointer-events: auto !important;
}
::ng-deep .annotationLayer section.esign-fill-field input,
::ng-deep .annotationLayer section.esign-fill-field textarea,
::ng-deep .annotationLayer section.esign-fill-field select {
  opacity: 1 !important;
  pointer-events: auto !important;
  -webkit-user-select: text !important;
          user-select: text !important;
  background-color: #fffbeb !important;
  border: 1px solid #f59e0b !important;
  color: #111827 !important;
  box-sizing: border-box;
}
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-required input,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-required textarea,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-required select {
  border-color: #dc2626 !important;
}
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-active input,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-active textarea,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-active select {
  outline: 3px solid #fbc02d !important;
  outline-offset: 1px;
}
::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox],
::ng-deep .annotationLayer section.esign-fill-field input[type=radio] {
  appearance: auto !important;
  accent-color: #16a34a;
  background-color: #ffffff !important;
}
::ng-deep .annotationLayer section.esign-fill-field input::placeholder,
::ng-deep .annotationLayer section.esign-fill-field textarea::placeholder {
  color: #c27e00;
  opacity: 1;
}

/* On a phone the page is drawn at about half its size, so a form's checkbox or radio button is 5-6px: hard to hit with a
   finger and hard to see. Draw it at 16px, centred on the same spot; what is saved is unchanged (IOHB-2000 QA). All three
   rules are for phones only: on a desktop the boxes look and work as before (IOHB-2118). */
@media (max-width: 991px), (pointer: coarse) {
  ::ng-deep {
    /* A ticked box or a chosen option stands out at a glance, after the signer has moved on to other fields. */
    /* pdf.js draws its own cross (checkbox) or dot (radio) on a ticked box with ::before/::after. Over the browser's own
       green tick that showed a tick and a cross at once, so only the browser's mark is kept. */
  }
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox],
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio] {
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    width: 16px !important;
    height: 16px !important;
    margin: 0 !important;
    transform: translate(-50%, -50%);
  }
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox]:checked,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio]:checked {
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.45) !important;
  }
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox]::before,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox]::after,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio]::before,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio]::after {
    content: none !important;
    display: none !important;
  }
}
/* Label above a field the signer fills in (IOHB-1886), sized and coloured like the signature labels. It sits in a row as
   wide as the page: the gap before it lines it up with its field and gives way where the page ends first, so a long label
   near the right edge moves left instead of running off the page (and one wider than the page is cut short). */
.esign-fill-tag-row {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 150;
  display: flex;
  pointer-events: none;
}

.esign-fill-tag-gap {
  flex: 0 1 auto;
  min-width: 0;
}

.esign-fill-tag {
  flex: none;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  font-size: 9px;
  font-weight: bold;
  line-height: normal;
  padding: 1px 4px;
  border-radius: 3px;
  white-space: nowrap;
}

.pdf-zoom-controls {
  position: absolute;
  right: 28px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}
.pdf-zoom-controls button {
  width: 38px !important;
  height: 38px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #2D388B !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  padding: 0 !important;
  transition: transform 0.1s ease, background-color 0.2s;
}
.pdf-zoom-controls button:hover:not(:disabled) {
  background-color: #f9fafb !important;
  transform: scale(1.05);
}
.pdf-zoom-controls button:active:not(:disabled) {
  transform: scale(0.95);
}
.pdf-zoom-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pdf-zoom-controls button i {
  font-size: 14px !important;
  font-weight: 700 !important;
}

.pdf-pages-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  min-width: 100%;
  transition: transform 0.1s ease-out;
  will-change: transform;
}

/* Electronic Signature Consent Modal & Blur Styling */
.consent-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  z-index: 2000;
  border-radius: 8px;
  padding: 1rem;
  overflow-y: auto;
}

.consent-modal-card {
  max-width: 500px;
  width: 100%;
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.consent-modal-card > *:not(.consent-disclosure-scroll) {
  flex: 0 0 auto;
}

.consent-disclosure-scroll {
  flex: 1 1 auto;
  min-height: 110px;
  display: flex;
  flex-direction: column;
}
.consent-disclosure-scroll .disclosure-box {
  max-height: none !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.consent-modal-footer {
  flex: 0 0 auto;
  border-top: 1px solid #e2e8f0;
  padding-top: 0.85rem;
  margin-top: 0.25rem;
}

@media (max-height: 800px) {
  .consent-modal-card .consent-modal-subline {
    display: none;
  }
  .consent-modal-card .consent-modal-header {
    margin-bottom: 0.75rem !important;
  }
}
@media (max-height: 680px) {
  .consent-modal-card {
    padding: 1.1rem !important;
  }
  .consent-modal-card .consent-modal-logo {
    display: none;
  }
  .consent-modal-card .consent-modal-title {
    font-size: 1rem;
  }
  .consent-modal-card .consent-modal-header {
    margin-bottom: 0.5rem !important;
  }
  .consent-modal-footer {
    padding-top: 0.6rem;
  }
  .consent-modal-footer .field-checkbox {
    padding: 0.6rem !important;
    margin-bottom: 0.6rem !important;
  }
}
.disclosure-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  overflow-y: auto;
  overscroll-behavior: contain;
  /* subtle inset shadow at the bottom edge hints there is more to read (scroll affordance) */
  box-shadow: inset 0 -10px 8px -8px rgba(15, 23, 42, 0.12);
}
.disclosure-box::-webkit-scrollbar {
  width: 10px;
}
.disclosure-box::-webkit-scrollbar-track {
  background: #e6e9f4;
  border-radius: 5px;
}
.disclosure-box::-webkit-scrollbar-thumb {
  background-color: #2d388b;
  border-radius: 5px;
  border: 2px solid #e6e9f4;
}
.disclosure-box::-webkit-scrollbar-thumb:hover {
  background-color: #242f74;
}

.blurred-console {
  filter: blur(5px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

/* Full Width mobile sign console optimization */
@media (max-width: 991px), (pointer: coarse) {
  .verfy-wrap {
    padding: 0px !important;
  }
  .verfy-wrap .verfy-box {
    margin-top: 0px !important;
    border-radius: 0px !important;
    border: none !important;
    box-shadow: none !important;
  }
  .verfy-wrap .verfy-box.wide-box {
    width: 100% !important;
    max-width: 100% !important;
    padding: 12px 8px !important;
  }
  .pdf-viewer-scroll {
    padding: 4px !important;
  }
  .grid {
    margin-left: -4px !important;
    margin-right: -4px !important;
    margin-top: 0px !important;
  }
  .grid > [class*=col-] {
    padding: 4px !important;
  }
}
.sig-panel-wrapper .redo-hover-overlay {
  transition: opacity 0.25s ease-in-out;
}
.sig-panel-wrapper:hover .redo-hover-overlay {
  opacity: 1 !important;
  pointer-events: auto !important;
}
@media (max-width: 991px), (pointer: coarse) {
  .sig-panel-wrapper .redo-hover-overlay {
    opacity: 1 !important;
    pointer-events: auto !important;
    background: transparent !important;
    backdrop-filter: none !important;
    justify-content: flex-end !important;
    align-items: flex-start !important;
    padding: 6px !important;
  }
  .sig-panel-wrapper .redo-hover-overlay button {
    padding: 4px 8px !important;
    font-size: 11px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }
}

@media (max-width: 991px), (pointer: coarse) {
  .verfy-wrap {
    padding: 0 !important;
    background: #dfe3ee !important;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .verfy-wrap .verfy-box {
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: #dfe3ee !important;
    box-shadow: none !important;
  }
  .verfy-wrap .verfy-box .pdf-container {
    flex: 1 1 auto;
    height: calc(100vh - 220px) !important;
    border-radius: 0 !important;
    border: none !important;
  }
  .mobile-topbar {
    flex: 0 0 auto;
    height: 52px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    background: #ffffff;
  }
  .mobile-topbar .brand-dot {
    background: #6ACE6A !important;
    font-weight: bold;
  }
  .mobile-bottom-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    box-shadow: 0 -6px 22px rgba(0, 0, 0, 0.1);
    border-top: 1px solid #e5e7eb;
    padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;
  }
  .mobile-bottom-bar .btn-primary {
    transition: background 0.15s, opacity 0.15s;
  }
  .mobile-bottom-bar .btn-primary:disabled {
    opacity: 0.45 !important;
    cursor: not-allowed !important;
  }
  .mobile-bottom-sheet {
    transform: translateY(110%);
    transition: transform 0.3s cubic-bezier(0.34, 1.3, 0.64, 1);
    box-sizing: border-box;
    border-top: 1px solid #cbd5e1;
    padding-bottom: calc(16px + env(safe-area-inset-bottom)) !important;
    max-height: calc(100vh - 56px);
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .mobile-bottom-sheet.show-sheet {
    transform: translateY(0);
  }
  .mobile-bottom-sheet .sheet-actions button {
    height: 44px !important;
    border-radius: 11px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mobile-bottom-sheet .sheet-actions .btn-clear, .mobile-bottom-sheet .sheet-actions .btn-close {
    border: 1px solid #cbd5e1 !important;
    background: #ffffff !important;
    color: #4b5563 !important;
    font-weight: 600;
  }
  .mobile-bottom-sheet .sheet-actions .btn-clear:hover, .mobile-bottom-sheet .sheet-actions .btn-close:hover {
    background: #f9fafb !important;
  }
  .mobile-bottom-sheet .sheet-actions .btn-apply {
    background: #2D388B !important;
    color: #ffffff !important;
  }
  .mobile-bottom-sheet .sheet-actions .btn-apply:disabled {
    opacity: 0.45 !important;
    cursor: not-allowed !important;
  }
  /* IOHB-1632 feedback: on touch devices the bottom sheet covers the PDF's lower
     edge, clipping the vertical zoom stack to just "+". Pin it to the top-right. */
  .pdf-zoom-controls {
    top: 12px !important;
    right: 12px !important;
    bottom: auto !important;
  }
  /* IOHB-1632 feedback: larger type-signature input on phones/tablets. */
  .mobile-type-sig-input {
    font-size: 20px !important;
    height: 50px !important;
  }
  .pdf-viewer-scroll {
    padding: 0 0 var(--sheet-pad, calc(120px + env(safe-area-inset-bottom))) 0 !important;
  }
}
/* IOHB-1632: guide the signer on mobile — pulse the active field + a floating tag.
   Scoped to <=991px so the desktop signing console is unaffected. */
@media (max-width: 991px), (pointer: coarse) {
  .active-sig-box {
    animation: sigPulse 1.25s ease-in-out infinite;
  }
  .sig-guide-tag {
    position: absolute;
    top: -34px;
    left: 0;
    background: #1e38a9;
    color: #fff;
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 12px;
    white-space: nowrap;
    box-shadow: 0 3px 8px rgba(30, 56, 169, 0.35);
    animation: sigBob 1s ease-in-out infinite;
    z-index: 160;
  }
}
@keyframes sigPulse {
  0%, 100% {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(251, 192, 45, 0);
  }
  50% {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15), 0 0 0 5px rgba(251, 192, 45, 0.35);
  }
}
@keyframes sigBob {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/e-soc/esign-verification/esign-verification.component.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADEA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mEAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAGF;AADE;EACE,gBAAA;EACA,mBAAA;AAGJ;AAAE;EACE,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,2CAAA;EACA,0EAAA;EACA,sBAAA;EA4DA,yBAAA;EAYA,4BAAA;EAUA,yBAAA;EAOA,oCAAA;AAnFJ;AAJI;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAMN;AAHI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAKN;AAFI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAIN;AADI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;AAGN;AADM;EACE,qBAAA;EACA,6CAAA;AAGR;AAAM;EACE,WAAA;EACA,YAAA;AAER;AACM;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AACR;AAII;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAFN;AAIM;EACE,YAAA;AAFR;AAOI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AALN;AASI;EACE,mBAAA;EACA,yBAAA;EACA,+CAAA;AAPN;AAWI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AATN;AAWM;EACE,mBAAA;AATR;AAWM;EACE,mBAAA;AATR;;AAeA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAZJ;AAeE;EACE,YAAA;AAbJ;AAcI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAZN;;AAiBA,eAAA;AACA;EACE,wCAAA;AAdF;;AAiBA;EACE;IACE,UAAA;IACA,2BAAA;EAdF;EAgBA;IACE,UAAA;IACA,wBAAA;EAdF;AACF;AAiBA,iDAAA;AAGI;EACE,WAAA;AAjBN;AAmBI;EACE,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,qBAAA;AAnBJ;AAqBI;EACE,mBAAA;EACA,qBAAA;AAnBN;;AAwBA;EAEI;IACE,WAAA;IACA,kBAAA;IACA,gBAAA;EAtBJ;EAwBI;IACE,WAAA;IACA,kBAAA;EAtBN;EAyBI;IACE,aAAA;EAvBN;EA0BI;IACE,gBAAA;IACA,gBAAA;EAxBN;AACF;AA6BA;;;;2FAAA;AAKA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA;;;iCAAA;EAIA,mBAAA;EACA,sKAAA;AA3BF;AA+BA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AA7BF;AA+BE;EACE,cAAA;EACA,oCAAA;AA7BJ;AAgCE;EACE,mBAAA;EACA,cAAA;EACA,wCAAA;AA9BJ;AAiCE;EACE,YAAA;EACA,mBAAA;AA/BJ;;AAmCA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;AAhCF;;AAmCA;EACE,kBAAA,EAAA,4CAAA;EACA,0BAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;AAhCF;AAkCE;EACE,qBAAA;AAhCJ;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA,EAAA,4DAAA;EACA,iBAAA;AAjCF;;AAoCA;oFAAA;AAEA;EACE,cAAA;AAjCF;;AAoCA;EACE,mBAAA;AAjCF;;AAqCE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,oDAAA;AAlCJ;AAoCI;EACE,8BAAA;EACA,gCAAA;AAlCN;AAqCI;EACE,8BAAA;EACA,gCAAA;AAnCN;AAsCI;EACE,8BAAA;EACA,gCAAA;AApCN;AAuCI;EACE,uBAAA;EACA,8BAAA;EACA,gCAAA;EACA,8BAAA;AArCN;;AA0CA,2DAAA;AACA;EA4BE,2IAAA;EAaA;6FAAA;EAsBA,oGAAA;EAaA,+FAAA;AA9GF;AAmCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,+BAAA,EAAA,0CAAA;AAjCJ;AAoCE;EACE,kBAAA;EACA,+BAAA;EACA,sBAAA;AAlCJ;AAqCE;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAnCJ;AAuCE;;;;;;;EAOE,qBAAA;EACA,+BAAA;EACA,oCAAA;UAAA,4BAAA;AArCJ;AA0CE;EACE,qBAAA;EACA,+BAAA;AAxCJ;AA0CE;;;EAGE,qBAAA;EACA,+BAAA;EACA,oCAAA;UAAA,4BAAA;EACA,oCAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;AAxCJ;AA0CE;;;EAGE,gCAAA;AAxCJ;AA2CE;;;EAGE,qCAAA;EACA,mBAAA;AAzCJ;AA2CE;;EAEE,2BAAA;EACA,qBAAA;EACA,oCAAA;AAzCJ;AA4CE;;EAEE,cAAA;EACA,UAAA;AA1CJ;;AA8CA;;2FAAA;AAGA;EACE;IAWE,2GAAA;IAKA;+FAAA;EAxDF;EAyCE;;IAEE,6BAAA;IACA,oBAAA;IACA,mBAAA;IACA,sBAAA;IACA,uBAAA;IACA,oBAAA;IACA,gCAAA;EAvCJ;EA0CE;;IAEE,wDAAA;EAxCJ;EA4CE;;;;IAIE,wBAAA;IACA,wBAAA;EA1CJ;AACF;AA8CA;;+GAAA;AAGA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AA5CF;;AA+CA;EACE,cAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,UAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;AA5CF;AA8CE;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,oDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,eAAA;EACA,qBAAA;EACA,sDAAA;AA5CJ;AA8CI;EACE,oCAAA;EACA,sBAAA;AA5CN;AA+CI;EACE,sBAAA;AA7CN;AAgDI;EACE,YAAA;EACA,mBAAA;AA9CN;AAiDI;EACE,0BAAA;EACA,2BAAA;AA/CN;;AAoDA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,sBAAA;AAjDF;;AAoDA,sDAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAjDF;;AAoDA;EACE,gBAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yDAAA;EACA,qFAAA;AAjDF;AAoDE;EACE,cAAA;AAlDJ;;AAwDA;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AArDF;AAuDE;EACE,2BAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AArDJ;;AA0DA;EACE,cAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;AAvDF;;AA4DA;EAEI;IAAyB,aAAA;EAzD3B;EA0DE;IAAwB,iCAAA;EAvD1B;AACF;AAyDA;EACE;IACE,0BAAA;EAvDF;EAwDE;IAAsB,aAAA;EArDxB;EAsDE;IAAuB,eAAA;EAnDzB;EAoDE;IAAwB,gCAAA;EAjD1B;EAmDA;IACE,mBAAA;EAjDF;EAkDE;IAAkB,0BAAA;IAA4B,gCAAA;EA9ChD;AACF;AAiDA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2FAAA;EACA,yDAAA;AA/CF;AAoDE;EACE,WAAA;AAlDJ;AAoDE;EACE,mBAAA;EACA,kBAAA;AAlDJ;AAoDE;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;AAlDJ;AAmDI;EACE,yBAAA;AAjDN;;AAsDA;EACE,iBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAnDF;;AAsDA,gDAAA;AACA;EACE;IACE,uBAAA;EAnDF;EAqDE;IACE,0BAAA;IACA,6BAAA;IACA,uBAAA;IACA,2BAAA;EAnDJ;EAqDI;IACE,sBAAA;IACA,0BAAA;IACA,4BAAA;EAnDN;EAwDA;IACE,uBAAA;EAtDF;EAyDA;IACE,4BAAA;IACA,6BAAA;IACA,0BAAA;EAvDF;EA0DA;IACE,uBAAA;EAxDF;AACF;AA4DE;EACE,qCAAA;AA1DJ;AA8DI;EACE,qBAAA;EACA,+BAAA;AA5DN;AAgEE;EACE;IACE,qBAAA;IACA,+BAAA;IACA,kCAAA;IACA,gCAAA;IACA,oCAAA;IACA,kCAAA;IACA,uBAAA;EA9DJ;EAgEI;IACE,2BAAA;IACA,0BAAA;IACA,mDAAA;EA9DN;AACF;;AAmEA;EACE;IACE,qBAAA;IACA,8BAAA;IACA,iBAAA;IACA,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;EAhEF;EAkEE;IACE,oBAAA;IACA,qBAAA;IACA,2BAAA;IACA,sBAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,2BAAA;EAhEJ;EAkEI;IACE,cAAA;IACA,sCAAA;IACA,2BAAA;IACA,uBAAA;EAhEN;EAqEA;IACE,cAAA;IACA,YAAA;IACA,sBAAA;IACA,yCAAA;IACA,mBAAA;EAnEF;EAqEE;IACE,8BAAA;IACA,iBAAA;EAnEJ;EAuEA;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,aAAA;IACA,0CAAA;IACA,6BAAA;IACA,mEAAA;EArEF;EAuEE;IACE,2CAAA;EArEJ;EAuEI;IACE,wBAAA;IACA,8BAAA;EArEN;EA0EA;IACE,2BAAA;IACA,2DAAA;IACA,sBAAA;IACA,6BAAA;IACA,mEAAA;IAKA,8BAAA;IACA,gBAAA;IACA,4BAAA;EA5EF;EA8EE;IACE,wBAAA;EA5EJ;EAgFI;IACE,uBAAA;IACA,8BAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA9EN;EAiFI;IACE,oCAAA;IACA,8BAAA;IACA,yBAAA;IACA,gBAAA;EA/EN;EAiFM;IACE,8BAAA;EA/ER;EAmFI;IACE,8BAAA;IACA,yBAAA;EAjFN;EAmFM;IACE,wBAAA;IACA,8BAAA;EAjFR;EAuFA;mFAAA;EAEA;IACE,oBAAA;IACA,sBAAA;IACA,uBAAA;EArFF;EAwFA,uEAAA;EACA;IACE,0BAAA;IACA,uBAAA;EAtFF;EAyFA;IAKE,qFAAA;EA3FF;AACF;AA8FA;oEAAA;AAEA;EACE;IACE,8CAAA;EA5FF;EA8FA;IACE,kBAAA;IACA,UAAA;IACA,OAAA;IACA,mBAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,6CAAA;IACA,yCAAA;IACA,YAAA;EA5FF;AACF;AA+FA;EACE;IAAW,yEAAA;EA5FX;EA6FA;IAAM,8EAAA;EA1FN;AACF;AA4FA;EACE;IAAW,wBAAA;EAzFX;EA0FA;IAAM,2BAAA;EAvFN;AACF","sourcesContent":["@import \"../../../assets/styles/colors.scss\";\n\n.verfy-wrap {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  background: url(../../../assets/images/mesh-gradient.png) center center;\n  background-size: cover;\n  flex-direction: column;\n  padding: 20px;\n  box-sizing: border-box;\n\n  .verfy-screen-logo {\n    margin-top: 40px;\n    margin-bottom: 20px;\n  }\n\n  .verfy-box {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(12px);\n    border-radius: 20px;\n    padding: 40px 60px;\n    text-align: center;\n    width: 600px;\n    margin-top: 170px;\n    max-width: 100%;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n    transition: margin-top 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s;\n    box-sizing: border-box;\n\n    &.wide-box {\n      width: 95%;\n      max-width: 1400px;\n      padding: 30px 40px;\n      margin-top: 50px;\n    }\n\n    h2 {\n      font-style: normal;\n      font-weight: 700;\n      font-size: 28px;\n      line-height: 34px;\n      color: #1f2937;\n      margin-top: 0;\n      margin-bottom: 12px;\n    }\n\n    p.subtitle {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      text-align: center;\n      color: #4b5563;\n      margin-bottom: 24px;\n    }\n\n    .Verify-dob {\n      border: 1px solid #d1d5db;\n      border-radius: 8px;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      gap: 15px;\n      margin-top: 30px;\n      padding: 0 16px;\n      height: 52px;\n      position: relative;\n      transition: border-color 0.2s, box-shadow 0.2s;\n\n      &:focus-within {\n        border-color: #2D388B;\n        box-shadow: 0 0 0 3px rgba(45, 56, 139, 0.15);\n      }\n\n      img {\n        width: 20px;\n        opacity: 0.6;\n      }\n\n      .input-mask-field {\n        border: none;\n        outline: none;\n        width: 100%;\n        font-size: 16px;\n      }\n    }\n\n    /* PDF Viewer Container */\n    .pdf-container {\n      background-color: #f3f4f6;\n      border: 1px solid #e5e7eb;\n      height: 750px;\n      position: relative;\n\n      .pdf-viewer-scroll {\n        cursor: grab;\n      }\n    }\n\n    /* Signature Sidebar Panel */\n    .sign-controls-card {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      height: 100%;\n      min-height: 400px;\n      background: #f9fafb;\n    }\n\n    /* Receipt card styling */\n    .receipt-card {\n      background: #f8fafc;\n      border: 1px solid #e2e8f0;\n      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.01);\n    }\n\n    /* Success / Error icon containers */\n    .status-icon-container {\n      width: 72px;\n      height: 72px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 0 auto 20px auto;\n\n      &.success-bg {\n        background: #ecfdf5;\n      }\n      &.error-bg {\n        background: #fef2f2;\n      }\n    }\n  }\n}\n\n.verify-agency-logo {\n  max-height: 80px;\n  max-width: 300px;\n  object-fit: contain;\n}\n\n.powered-wrapper {\n  margin-top: 40px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 6px;\n  flex-direction: column;\n  align-items: center;\n\n  span {\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 14px;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n    color: #4b5563;\n  }\n\n  .image-wrapper {\n    width: 140px;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n}\n\n/* Animations */\n.fade-in {\n  animation: fadeIn 0.4s ease-out forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Custom Overrides for Calendar/PrimeNG Inputs */\n::ng-deep {\n  .disable-calendar {\n    .p-calendar {\n      width: 100%;\n    }\n    .p-inputtext {\n      border: none !important;\n      box-shadow: none !important;\n      padding: 0 !important;\n      height: 48px;\n      font-size: 16px;\n      width: 100%;\n    }\n  }\n\n  .p-checkbox .p-checkbox-box {\n    border-radius: 4px;\n    border-color: #d1d5db;\n\n    &.p-highlight {\n      background: #2D388B;\n      border-color: #2D388B;\n    }\n  }\n}\n\n@media (max-width: 991px), (pointer: coarse) {\n  .verfy-wrap {\n    .verfy-box {\n      width: 100%;\n      padding: 30px 20px;\n      margin-top: 10px;\n\n      &.wide-box {\n        width: 100%;\n        padding: 24px 16px;\n      }\n\n      .pdf-container {\n        height: 400px;\n      }\n\n      .sign-controls-card {\n        min-height: auto;\n        margin-top: 20px;\n      }\n    }\n  }\n}\n\n/* Caveat handwriting font for typed signatures. CDN-first with a self-hosted fallback: the\n   browser tries the CDN, and if that request fails (offline, blocked on a locked-down clinical\n   network, or a stale URL) it uses the bundled copy — so the signature always renders in the\n   font the signer saw, and the WYSIWYG guarantee holds everywhere.\n   Caveat is licensed under the SIL Open Font License 1.1 — see src/assets/fonts/OFL.txt. */\n@font-face {\n  font-family: 'Caveat';\n  font-style: normal;\n  font-weight: 700;\n  /* 'block' (not 'swap') so the typed signature never renders in a fallback font and then visibly\n     swaps to Caveat — during the brief load it stays hidden instead of flashing the wrong font.\n     Combined with the ngOnInit preload, Caveat is loaded well before the Type step, so there is no\n     visible delay in practice. */\n  font-display: block;\n  src: url('https://cdn.jsdelivr.net/npm/@fontsource/caveat/files/caveat-latin-700-normal.woff2') format('woff2'),\n       url('/assets/fonts/caveat-700.woff2') format('woff2');\n}\n\n.sig-tabs {\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 2px;\n  display: flex;\n  gap: 4px;\n}\n\n.sig-tab-btn {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #4b5563;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  outline: none;\n\n  &:hover {\n    color: #1f2937;\n    background: rgba(255, 255, 255, 0.5);\n  }\n\n  &.active {\n    background: #ffffff;\n    color: #2d388b;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.sig-panel {\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.sig-canvas {\n  touch-action: none; /* prevent browser scrolling while drawing */\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  transition: border-color 0.2s;\n  display: block;\n\n  &:hover {\n    border-color: #9ca3af;\n  }\n}\n\n.type-sig-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  background-color: #f9fafb;\n  color: #000000; /* typed signature ink is black (matches drawn signatures) */\n  font-weight: bold;\n}\n\n/* Unified accent ink (io navy) — replaces the stray indigo/purple accents on the\n   signing page so labels, badges and the typed-signature preview match the theme. */\n.io-ink {\n  color: #2D388B;\n}\n\n.io-ink-soft-bg {\n  background: #eef1fb;\n}\n\n::ng-deep {\n  .esign-green-btn {\n    background: $Green !important;\n    border: 1px solid $Green !important;\n    color: #ffffff !important;\n    transition: background-color 0.2s, border-color 0.2s;\n\n    &:hover:not(:disabled) {\n      background: $Greenlight !important;\n      border-color: $Greenlight !important;\n    }\n\n    &:focus:not(:disabled) {\n      background: $GreenDark !important;\n      border-color: $GreenDark !important;\n    }\n\n    &:active:not(:disabled) {\n      background: $GreenDark !important;\n      border-color: $GreenDark !important;\n    }\n\n    &:disabled {\n      opacity: 0.6 !important;\n      background: $Green !important;\n      border-color: $Green !important;\n      cursor: not-allowed !important;\n    }\n  }\n}\n\n/* PDF.js Annotation Layer Styles (Read-only for patient) */\n::ng-deep {\n  .annotationLayer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 1;\n    line-height: 1;\n    pointer-events: none !important; /* Patient cannot interact/change values */\n  }\n\n  .annotationLayer > * {\n    position: absolute;\n    pointer-events: none !important;\n    box-sizing: border-box;\n  }\n\n  .annotationLayer .linkAnnotation > a {\n    position: absolute;\n    font-size: 1em;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none !important;\n  }\n\n  /* Hide all widgets in the annotation layer completely to prevent duplicate text overlay, but keep them in layout tree for auto-placement */\n  .annotationLayer input,\n  .annotationLayer textarea,\n  .annotationLayer select,\n  .annotationLayer button,\n  .annotationLayer .buttonWidgetAnnotation,\n  .annotationLayer .textWidgetAnnotation,\n  .annotationLayer .choiceWidgetAnnotation {\n    opacity: 0 !important;\n    pointer-events: none !important;\n    user-select: none !important;\n  }\n\n  /* Fields this signer fills in (IOHB-1779): shown and editable over the page. The opaque background\n     covers the page's own rendering of the field underneath, so a value never shows twice. */\n  .annotationLayer section.esign-fill-field {\n    opacity: 1 !important;\n    pointer-events: auto !important;\n  }\n  .annotationLayer section.esign-fill-field input,\n  .annotationLayer section.esign-fill-field textarea,\n  .annotationLayer section.esign-fill-field select {\n    opacity: 1 !important;\n    pointer-events: auto !important;\n    user-select: text !important;\n    background-color: #fffbeb !important;\n    border: 1px solid #f59e0b !important;\n    color: #111827 !important;\n    box-sizing: border-box;\n  }\n  .annotationLayer section.esign-fill-field.esign-fill-required input,\n  .annotationLayer section.esign-fill-field.esign-fill-required textarea,\n  .annotationLayer section.esign-fill-field.esign-fill-required select {\n    border-color: #dc2626 !important;\n  }\n  /* The field the signer is on (IOHB-1884), outlined in the same yellow as the active signature box */\n  .annotationLayer section.esign-fill-field.esign-fill-active input,\n  .annotationLayer section.esign-fill-field.esign-fill-active textarea,\n  .annotationLayer section.esign-fill-field.esign-fill-active select {\n    outline: 3px solid #fbc02d !important;\n    outline-offset: 1px;\n  }\n  .annotationLayer section.esign-fill-field input[type=\"checkbox\"],\n  .annotationLayer section.esign-fill-field input[type=\"radio\"] {\n    appearance: auto !important;\n    accent-color: #16a34a;\n    background-color: #ffffff !important;\n  }\n  /* Guide text in an empty field the signer fills in (IOHB-1886), in the colour of \"Sign Here\" */\n  .annotationLayer section.esign-fill-field input::placeholder,\n  .annotationLayer section.esign-fill-field textarea::placeholder {\n    color: #c27e00;\n    opacity: 1;\n  }\n}\n\n/* On a phone the page is drawn at about half its size, so a form's checkbox or radio button is 5-6px: hard to hit with a\n   finger and hard to see. Draw it at 16px, centred on the same spot; what is saved is unchanged (IOHB-2000 QA). All three\n   rules are for phones only: on a desktop the boxes look and work as before (IOHB-2118). */\n@media (max-width: 991px), (pointer: coarse) {\n  ::ng-deep {\n    .annotationLayer section.esign-fill-field input[type=\"checkbox\"],\n    .annotationLayer section.esign-fill-field input[type=\"radio\"] {\n      position: absolute !important;\n      left: 50% !important;\n      top: 50% !important;\n      width: 16px !important;\n      height: 16px !important;\n      margin: 0 !important;\n      transform: translate(-50%, -50%);\n    }\n    /* A ticked box or a chosen option stands out at a glance, after the signer has moved on to other fields. */\n    .annotationLayer section.esign-fill-field input[type=\"checkbox\"]:checked,\n    .annotationLayer section.esign-fill-field input[type=\"radio\"]:checked {\n      box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.45) !important;\n    }\n    /* pdf.js draws its own cross (checkbox) or dot (radio) on a ticked box with ::before/::after. Over the browser's own\n       green tick that showed a tick and a cross at once, so only the browser's mark is kept. */\n    .annotationLayer section.esign-fill-field input[type=\"checkbox\"]::before,\n    .annotationLayer section.esign-fill-field input[type=\"checkbox\"]::after,\n    .annotationLayer section.esign-fill-field input[type=\"radio\"]::before,\n    .annotationLayer section.esign-fill-field input[type=\"radio\"]::after {\n      content: none !important;\n      display: none !important;\n    }\n  }\n}\n\n/* Label above a field the signer fills in (IOHB-1886), sized and coloured like the signature labels. It sits in a row as\n   wide as the page: the gap before it lines it up with its field and gives way where the page ends first, so a long label\n   near the right edge moves left instead of running off the page (and one wider than the page is cut short). */\n.esign-fill-tag-row {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 150;\n  display: flex;\n  pointer-events: none;\n}\n\n.esign-fill-tag-gap {\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.esign-fill-tag {\n  flex: none;\n  box-sizing: border-box;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #fff;\n  font-size: 9px;\n  font-weight: bold;\n  line-height: normal;\n  padding: 1px 4px;\n  border-radius: 3px;\n  white-space: nowrap;\n}\n\n.pdf-zoom-controls {\n  position: absolute;\n  right: 28px;\n  bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 1000;\n\n  button {\n    width: 38px !important;\n    height: 38px !important;\n    border-radius: 10px !important;\n    background: #ffffff !important;\n    border: 1px solid #e5e7eb !important;\n    color: #2D388B !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    cursor: pointer;\n    padding: 0 !important;\n    transition: transform 0.1s ease, background-color 0.2s;\n\n    &:hover:not(:disabled) {\n      background-color: #f9fafb !important;\n      transform: scale(1.05);\n    }\n\n    &:active:not(:disabled) {\n      transform: scale(0.95);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    i {\n      font-size: 14px !important;\n      font-weight: 700 !important;\n    }\n  }\n}\n\n.pdf-pages-container {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 100%;\n  transition: transform 0.1s ease-out;\n  will-change: transform;\n}\n\n/* Electronic Signature Consent Modal & Blur Styling */\n.consent-modal-overlay {\n  position: fixed;          // anchor to the viewport (was absolute — a tall page could centre the card off-screen)\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  z-index: 2000;\n  border-radius: 8px;\n  padding: 1rem;\n  overflow-y: auto;         // fallback: if a card ever exceeds the viewport, scroll the overlay instead of clipping\n}\n\n.consent-modal-card {\n  max-width: 500px;\n  width: 100%;\n  max-height: calc(100vh - 2rem);   // never taller than the viewport (minus the overlay's 1rem padding top+bottom)\n  display: flex;                    // column layout: fixed header, scrolling disclosure, pinned footer\n  flex-direction: column;\n  overflow: hidden;                 // the card itself never clips the buttons — the disclosure region scrolls instead\n  animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  // everything except the disclosure keeps its natural height and stays visible\n  > *:not(.consent-disclosure-scroll) {\n    flex: 0 0 auto;\n  }\n}\n\n// The disclosure is the main scrolling region; it takes the leftover height and shrinks on short\n// screens — but keeps a readable floor so it never collapses to a thin sliver.\n.consent-disclosure-scroll {\n  flex: 1 1 auto;\n  min-height: 110px;       // readable floor (~a few lines); grows to fill on taller screens\n  display: flex;\n  flex-direction: column;\n\n  .disclosure-box {\n    max-height: none !important;   // override the shared template's inline 40vh — in the modal the height is flex-driven\n    flex: 1 1 auto;\n    min-height: 0;                 // inner box may shrink so it scrolls within the wrapper\n    overflow-y: auto;\n  }\n}\n\n// Pinned, always-visible action bar at the bottom of the card (DocuSign-style).\n.consent-modal-footer {\n  flex: 0 0 auto;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 0.85rem;\n  margin-top: 0.25rem;\n}\n\n// Short / display-scaled screens: reclaim vertical space so the disclosure stays a readable size\n// (instead of a sliver) while the footer buttons remain visible. Drop the least-important chrome first.\n@media (max-height: 800px) {\n  .consent-modal-card {\n    .consent-modal-subline { display: none; }              // hide the \"invited you on …\" line\n    .consent-modal-header { margin-bottom: 0.75rem !important; }\n  }\n}\n@media (max-height: 680px) {\n  .consent-modal-card {\n    padding: 1.1rem !important;                            // tighten card padding (overrides p-4 / md:p-5)\n    .consent-modal-logo { display: none; }                 // hide the logo\n    .consent-modal-title { font-size: 1rem; }              // smaller title\n    .consent-modal-header { margin-bottom: 0.5rem !important; }\n  }\n  .consent-modal-footer {\n    padding-top: 0.6rem;\n    .field-checkbox { padding: 0.6rem !important; margin-bottom: 0.6rem !important; }\n  }\n}\n\n.disclosure-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  overflow-y: auto;                 // guarantee the scroll regardless of utility classes\n  overscroll-behavior: contain;     // scrolling the disclosure doesn't scroll the page behind it\n  /* subtle inset shadow at the bottom edge hints there is more to read (scroll affordance) */\n  box-shadow: inset 0 -10px 8px -8px rgba(15, 23, 42, 0.12);\n  // Wider, brand-blue scrollbar so the \"there is more to read\" affordance is obvious (helps the\n  // signer scroll to the end, which the consent gate requires). Use the WebKit pseudo-elements only\n  // (Chrome/Edge/Safari) — do NOT set the standard `scrollbar-width`, because in Chrome 121+ that\n  // takes over and renders a thin bar, ignoring the width below.\n  &::-webkit-scrollbar {\n    width: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    background: #e6e9f4;\n    border-radius: 5px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #2d388b;       // io navy/blue (was grey #cbd5e1)\n    border-radius: 5px;\n    border: 2px solid #e6e9f4;       // inset so the thumb reads as a rounded blue pill\n    &:hover {\n      background-color: #242f74;\n    }\n  }\n}\n\n.blurred-console {\n  filter: blur(5px);\n  pointer-events: none;\n  user-select: none;\n}\n\n/* Full Width mobile sign console optimization */\n@media (max-width: 991px), (pointer: coarse) {\n  .verfy-wrap {\n    padding: 0px !important;\n\n    .verfy-box {\n      margin-top: 0px !important;\n      border-radius: 0px !important;\n      border: none !important;\n      box-shadow: none !important;\n\n      &.wide-box {\n        width: 100% !important;\n        max-width: 100% !important;\n        padding: 12px 8px !important;\n      }\n    }\n  }\n\n  .pdf-viewer-scroll {\n    padding: 4px !important;\n  }\n\n  .grid {\n    margin-left: -4px !important;\n    margin-right: -4px !important;\n    margin-top: 0px !important;\n  }\n\n  .grid > [class*=\"col-\"] {\n    padding: 4px !important;\n  }\n}\n\n.sig-panel-wrapper {\n  .redo-hover-overlay {\n    transition: opacity 0.25s ease-in-out;\n  }\n\n  &:hover {\n    .redo-hover-overlay {\n      opacity: 1 !important;\n      pointer-events: auto !important;\n    }\n  }\n\n  @media (max-width: 991px), (pointer: coarse) {\n    .redo-hover-overlay {\n      opacity: 1 !important;\n      pointer-events: auto !important;\n      background: transparent !important;\n      backdrop-filter: none !important;\n      justify-content: flex-end !important;\n      align-items: flex-start !important;\n      padding: 6px !important;\n\n      button {\n        padding: 4px 8px !important;\n        font-size: 11px !important;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 991px), (pointer: coarse) {\n  .verfy-wrap {\n    padding: 0 !important;\n    background: #dfe3ee !important;\n    min-height: 100vh;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    .verfy-box {\n      margin: 0 !important;\n      padding: 0 !important;\n      border-radius: 0 !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      min-height: 100vh;\n      min-height: 100dvh;\n      display: flex;\n      flex-direction: column;\n      background: #dfe3ee !important;\n      box-shadow: none !important;\n\n      .pdf-container {\n        flex: 1 1 auto;\n        height: calc(100vh - 220px) !important;\n        border-radius: 0 !important;\n        border: none !important;\n      }\n    }\n  }\n\n  .mobile-topbar {\n    flex: 0 0 auto;\n    height: 52px;\n    box-sizing: border-box;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    background: #ffffff;\n\n    .brand-dot {\n      background: #6ACE6A !important;\n      font-weight: bold;\n    }\n  }\n\n  .mobile-bottom-bar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000;\n    box-shadow: 0 -6px 22px rgba(0, 0, 0, 0.1);\n    border-top: 1px solid #e5e7eb;\n    padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;\n\n    .btn-primary {\n      transition: background 0.15s, opacity 0.15s;\n\n      &:disabled {\n        opacity: 0.45 !important;\n        cursor: not-allowed !important;\n      }\n    }\n  }\n\n  .mobile-bottom-sheet {\n    transform: translateY(110%);\n    transition: transform 0.3s cubic-bezier(0.34, 1.3, 0.64, 1);\n    box-sizing: border-box;\n    border-top: 1px solid #cbd5e1;\n    padding-bottom: calc(16px + env(safe-area-inset-bottom)) !important;\n    // Never taller than the viewport (leave a sliver of the doc/topbar). On short viewports —\n    // e.g. a phone in LANDSCAPE — the sheet's own content scrolls, so the Apply/Close buttons stay\n    // reachable instead of overflowing off-screen; and it keeps room for the doc to scroll clear of\n    // it. Portrait is unaffected (the sheet is shorter than the screen there). IOHB-1676.\n    max-height: calc(100vh - 56px);\n    overflow-y: auto;\n    overscroll-behavior: contain;\n\n    &.show-sheet {\n      transform: translateY(0);\n    }\n\n    .sheet-actions {\n      button {\n        height: 44px !important;\n        border-radius: 11px !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .btn-clear, .btn-close {\n        border: 1px solid #cbd5e1 !important;\n        background: #ffffff !important;\n        color: #4b5563 !important;\n        font-weight: 600;\n\n        &:hover {\n          background: #f9fafb !important;\n        }\n      }\n\n      .btn-apply {\n        background: #2D388B !important;\n        color: #ffffff !important;\n\n        &:disabled {\n          opacity: 0.45 !important;\n          cursor: not-allowed !important;\n        }\n      }\n    }\n  }\n\n  /* IOHB-1632 feedback: on touch devices the bottom sheet covers the PDF's lower\n     edge, clipping the vertical zoom stack to just \"+\". Pin it to the top-right. */\n  .pdf-zoom-controls {\n    top: 12px !important;\n    right: 12px !important;\n    bottom: auto !important;\n  }\n\n  /* IOHB-1632 feedback: larger type-signature input on phones/tablets. */\n  .mobile-type-sig-input {\n    font-size: 20px !important;\n    height: 50px !important;\n  }\n\n  .pdf-viewer-scroll {\n    // No side/top padding on mobile, but reserve bottom room so the LAST page can scroll clear of\n    // whatever overlaps the bottom. Default = the fixed .mobile-bottom-bar (~120px). When the\n    // signature sheet is open the component measures it and sets --sheet-pad to the sheet's height,\n    // so the whole document (incl. its bottom) can scroll clear of the taller sheet too. IOHB-1676.\n    padding: 0 0 var(--sheet-pad, calc(120px + env(safe-area-inset-bottom))) 0 !important;\n  }\n}\n\n/* IOHB-1632: guide the signer on mobile — pulse the active field + a floating tag.\n   Scoped to <=991px so the desktop signing console is unaffected. */\n@media (max-width: 991px), (pointer: coarse) {\n  .active-sig-box {\n    animation: sigPulse 1.25s ease-in-out infinite;\n  }\n  .sig-guide-tag {\n    position: absolute;\n    top: -34px;\n    left: 0;\n    background: #1e38a9;\n    color: #fff;\n    font-size: 9.5px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 12px;\n    white-space: nowrap;\n    box-shadow: 0 3px 8px rgba(30, 56, 169, 0.35);\n    animation: sigBob 1s ease-in-out infinite;\n    z-index: 160;\n  }\n}\n\n@keyframes sigPulse {\n  0%, 100% { box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(251, 192, 45, 0); }\n  50% { box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15), 0 0 0 5px rgba(251, 192, 45, 0.35); }\n}\n\n@keyframes sigBob {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n}\n\n\n","/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
